import React, { useState, useEffect } from 'react';
import axios from 'axios';
// import '../Login/Index.css'

import { useForm, Controller } from 'react-hook-form';
import { useNavigate } from "react-router-dom";

import { login, triggerAlert, getToken, set_user_menu_permission } from '../../utils';
//import Loader from '../../common/Loader';
import Cookies from 'js-cookie';
export default function Login() {
    document.title = "Digital Employees | Login";
    const [captchaUrl, setCaptchaUrl] = useState('');
    const [userCaptchaInput, setUserCaptchaInput] = useState('');
    const [isCaptchaValid, setIsCaptchaValid] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [password, setPassword] = useState("");

    const [isLoading, setIsLoading] = useState(false);
    const [passwordType, setPasswordType] = useState("password");


    const api_url = process.env.REACT_APP_API_BASE_URL;
    const api_url_cust = process.env.REACT_APP_API_CUSTOMER_URL;

    const { control, register, handleSubmit, formState: { errors }, setValue, getValues } = useForm();

    const navigate = useNavigate();

    const togglePassword = () => {
        if (passwordType === "password") {
            setPasswordType("text");
        } else {
            setPasswordType("password");
        }
    };

    const refreshCaptcha = async () => {
        // Add code to refresh the captcha
        //setCaptchaUrl(api_url_cust+`forms/GenerateCaptcha/?${Date.now()}`);
        // console.log(captchaUrl)
        try {
            axios.defaults.headers.common = { 'Authorization': `` }
            const response = await axios.get('api/admin/generate-captcha/');
            if (response.status === 200) {
                const data = await response.data;

                // Set the CAPTCHA text
                setIsCaptchaValid(data.captcha_text);

                // Set the CAPTCHA image by creating a data URL
                setCaptchaUrl(`data:image/png;base64, ${data.image_data}`);
            }
        } catch (error) {
            console.error(error);
        }
    };
    useEffect(() => {
        refreshCaptcha()
    }, [])
    const loginSubmit = async (data) => {
        // console.log(isCaptchaValid);
        // console.log(userCaptchaInput);

        //const userInputMatchesCaptcha = userCaptchaInput !== "";
        //setIsCaptchaValid(userInputMatchesCaptcha);
        // if (isCaptchaValid == userCaptchaInput) {
        setIsLoading(true);
        try {
            const response = await axios.post('api/admin/user/login/', data);
            const response_data = response.data;
            //console.log(response_data.results.token);
            //console.log(response_data.results);
            if (response_data.status == 200) {
                var token = response_data.token.access;
                var user_data = response_data;
                axios.defaults.headers.common = { 'Authorization': `Bearer ${token}` }
                // var customer_id = 0;
                // var auth_user = "";
                // var company_name = "";
                var username = "";
                var email = "";
                var user_type = "";
                var admin_id = 0;
                if (user_data) {
                    // auth_user = user_data.user.first_name + " " + user_data.user.last_name;
                    // company_name = user_data.user.company_name;
                    // customer_id = user_data.user.id;
                    username = user_data.name;
                    email = user_data.user.email;
                    user_type = user_data.role_id;
                    admin_id = user_data.user;
                }

                if (token) {
                    fetchMenuListApi(user_type);
                    login(token, username, email, user_type, admin_id);
                    //login(token, auth_user, company_name, customer_id);
                    // const admin_token = getToken();
                    // fetchUserMenuPermissionData(admin_token)
                    // navigate('/dashboard');
                    setIsLoading(false);
                } else {
                    setIsLoading(false);
                    triggerAlert('error', 'Oops...', 'Invalid Login Credentials');
                }
            } else {
                setIsLoading(false);
                triggerAlert('error', 'Oops...', 'Invalid Login Credentials');
            }
        } catch (error) {
            //console.log(error);
            //console.log(error.response.data.message);
            //error.response.status=="Request failed with status code 401"
            if (error?.response?.status == "401") {
                triggerAlert('error', 'Oops...', error.response.data.message);
            } else {
                triggerAlert('error', 'Oops...', 'Invalid Login Credentials');
            }
            setIsLoading(false);
            //triggerAlert('error', 'Oops...', 'Invalid Login..');
            // 
        }
        // }
        // else {
        //     //console.log('Captcha is invalid. Please try again.');
        //     triggerAlert('error', 'Oops...', 'Invalid Captcha');
        // }
    };

    const fetchUserMenuPermissionData = async (token) => {

        try {

            const response = await axios.get(api_url + 'get_user_menu_permissions', token);
            const response_data = response.data

            if (response.status === 200) {
                const itemsArray = response_data.results;

                const menu_id_add_array = itemsArray.menu_id_add.split(',').map(Number);
                const menu_id_edit_array = itemsArray.menu_id_edit.split(',').map(Number);
                const menu_id_delete_array = itemsArray.menu_id_delete.split(',').map(Number);
                const excel_export_array = itemsArray.excel_export.split(',').map(Number);

                set_user_menu_permission(menu_id_add_array, menu_id_edit_array, menu_id_delete_array, excel_export_array);

            } else if (response.status === 204) {

            }
            else {
                // triggerAlert('error', 'Oops...', 'Something went wrong here..');
            }

        } catch (error) {
            // triggerAlert('error', 'Oops...', 'Something went wrong..');
        }
    };

    const fetchMenuListApi = async (data) => {
        let role_id = data
        try {
            const response = await axios.get(`/api/admin/module-mappings/?role_id=${role_id}`);
            const response_data = response.data
            if (response.status === 200) {
                const itemsArray = response_data.results;
                // sessionStorage.setItem('modulepermissions',  JSON.stringify(itemsArray))
                Cookies.set('modulepermissions', JSON.stringify(itemsArray));
                navigate('/dashboard');
            }

        } catch (error) {
            // triggerAlert('error', 'Oops...', 'Something went wrong..');
        }
    };

    // console.log(getValues());

    return (
        <div className="login-wrapper">
            {/* LEFT PANEL */}
            <div className="login-left pb-5">
                <div className=" text-white">
                    <h1 className="gradient-text">
                        Manage Your Digital Employees Efficiently.
                    </h1>

                    <p className='text-center'>"Streamline operations, empower your workforce"</p>
                </div>
            </div>

            {/* RIGHT PANEL */}
            <div className="login-right">
                <div className="login-card">

                    {/* LOGO */}
                    <div className='text-center'>
                        <img
                            src="/assets/images/logoblack.png"
                            alt="Login Logo"
                            style={{ width: '220px', marginBottom: '20px' }}
                        />
                    </div>

                    <h2 className='text-primary'>Admin Access</h2>
                    <p className="sub-text">
                        Enter your credentials to manage your digital workforce
                    </p>

                    <form onSubmit={handleSubmit(loginSubmit)} className="w-100">

                        {/* EMAIL */}
                        <div className="mb-3">
                            <label className="form-label">Email</label>
                            <input
                                type="text"
                                className='form-control'
                                placeholder="Enter your email"
                                {...register('email', {
                                    required: 'Email is required',
                                    pattern: {
                                        value: /^[0-9+]{10}|\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,5})+$/,
                                        message: 'Please enter valid email id',
                                    },
                                })}
                            />
                            {errors.email && (
                                <span className="error">{errors.email.message}</span>
                            )}
                        </div>

                        {/* PASSWORD */}
                        <div className="mb-3">
                            <label className="form-label">Password</label>
                            <div className="password-box">
                                <input
                                    className='form-control'
                                    type={showPassword ? 'text' : 'password'}
                                    placeholder="Enter password"
                                    {...register('password', {
                                        required: 'Password is required',
                                        minLength: { value: 6, message: 'Min length is 6' },
                                        maxLength: { value: 25, message: 'Max length exceeded' },
                                        pattern: {
                                            value: /^[a-zA-Z0-9@+-]+$/,
                                            message: 'Allowed: alphabets, numbers, @ + -',
                                        },
                                    })}
                                />
                                <span onClick={() => setShowPassword(prev => !prev)}>
                                    {showPassword ? '🙈' : '👁'}
                                </span>
                            </div>
                            {errors.password && (
                                <span className="error">{errors.password.message}</span>
                            )}
                        </div>

                        {/* CAPTCHA */}
                        <div className="mb-3">
                            <label className="form-label">Verification Code</label>
                            <div className="captcha-row">
                                <input
                                    className='form-control'
                                    type="text"
                                    placeholder="Enter verification code"
                                    value={userCaptchaInput}
                                    onChange={(e) => setUserCaptchaInput(e.target.value)}
                                />

                                <div className="captcha-box">
                                    <img
                                        src={captchaUrl}
                                        alt="captcha"
                                        style={{ height: '38px' }}
                                    />
                                    <button
                                        type="button"
                                        className="refresh-btn"
                                        onClick={refreshCaptcha}
                                    >
                                        ⟳
                                    </button>
                                </div>
                            </div>
                        </div>

                        {/* OPTIONS */}
                        <div className="options my-2">
                            <label className="form-check-label ">
                                <input type="checkbox" className="form-check-input" /> Remember me
                            </label>
                            {/* <a href="#">Forgot password?</a> */}
                        </div>

                        {/* SUBMIT */}
                        <button type="submit" className='btn btn-primary w-100 mt-3' disabled={isLoading}>
                            {isLoading ? (
                                <>
                                    <span className="spinner"></span> Signing in...
                                </>
                            ) : (
                                'Sign In'
                            )}
                        </button>

                    </form>

                </div>


            </div>
        </div>
    );

};
